import React from 'react';
import { Typography } from '@kiiwi/ui';
import { CardHcdAvailabilitySubstituteDTO } from '@maiia/model/generated/model/api-patient/api-patient';
import { useTranslation } from '@/src/i18n';

type ProCardSubstituteInfoProps = {
  substitute: CardHcdAvailabilitySubstituteDTO;
};

const ProCardSubstituteInfo = ({ substitute }: ProCardSubstituteInfoProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-row items-center justify-center gap-2">
      <div className="size-2 min-w-2 rounded-full bg-macro-primary-enabled" />
      <Typography variant="body-2" className="text-neutral-secondary">
        {t('pro_card_appointment_with_substitute', {
          name: `${substitute.firstName} ${substitute.lastName}`,
        })}
      </Typography>
    </div>
  );
};

export default ProCardSubstituteInfo;
